import { useEffect, useMemo, useState } from "react";

import Cookies from "js-cookie";
import AuthContext from "./authContext";

export const initialLoginState: stateType = {
  token: "",
  email: "",
  level: "",
  name: "",
  user_id: "",
};

const AuthState = (props: { children: React.ReactNode }) => {
  const { children } = props;

  const [state, setState] = useState<stateType>(initialLoginState);

  useEffect(() => {
    const userData = Cookies.get("userData") || "";
    const parsedUserData = userData ? JSON.parse(userData) : null;

    if (parsedUserData) {
      setState({
        token: parsedUserData?.access_token || "",
        email: parsedUserData?.user?.email || "",
        level: parsedUserData?.user?.level || "",
        name: parsedUserData?.user?.name || "",
        user_id: parsedUserData?.user?.user_id || "",
      });
    }
  }, []);

  const stateValue = useMemo(() => [{ state, setState }], [state, setState]);

  return (
    <AuthContext.Provider value={stateValue}> {children}</AuthContext.Provider>
  );
};

export default AuthState;
